export default __webpack_public_path__ + "static/media/change-client-icon.e4e6e46a.svg";